import React, { useState } from 'react';
import { Button } from '@/components/v1/Button';
import { getContractInfo, type ContractInfo } from '@/api/smart-contracts';

type ContractLookupProps = {
  onResponse?: (data: ContractInfo) => void;
  onError?: (message: string) => void;
  chainId?: string;
};

export function ContractLookup({
  onResponse,
  onError,
  chainId = '1',
}: ContractLookupProps) {
  const [address, setAddress] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleGet() {
    const trimmed = address.trim();
    if (!trimmed) {
      onError?.('Please enter a contract address.');
      return;
    }
    setLoading(true);
    onError?.('');
    try {
      const data = await getContractInfo(trimmed, chainId);
      onResponse?.(data);
    } catch (err) {
      onError?.(err instanceof Error ? err.message : 'Request failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full max-w-2xl">
      <input
        type="text"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleGet()}
        placeholder="0x..."
        className="flex-1 min-w-0 px-4 py-2.5 rounded-lg bg-gray-800 border border-gray-600 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        disabled={loading}
        aria-label="Contract address"
      />
      <Button
        onClick={handleGet}
        disabled={loading}
        loading={loading}
        variant="primary"
      >
        Get
      </Button>
    </div>
  );
}
